"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchDownloadDatepicker = void 0;
/* ========================================================================
    Module: Date picker
 ========================================================================== */
const jquery_1 = __importDefault(require("jquery"));
require("jquery-ui/ui/widgets/datepicker");
require("jquery-ui/ui/i18n/datepicker-ja");
const dateFormat = "yy/mm/dd";
const regional = jquery_1.default.datepicker.regional["ja"];
const optionDefaults = {
    dateFormat: dateFormat,
    minDate: new Date(2023, 4, 1),
};
/**
 * 一括ダウンロードの Date picker を設定する
 *
 * Required: jQuery, jQuery UI Datepicker
 *
 * @returns {void}
 */
const batchDownloadDatepicker = () => {
    jquery_1.default.datepicker.setDefaults(regional);
    jquery_1.default.datepicker.setDefaults(optionDefaults);
    (0, jquery_1.default)(".js-batch-download-button").on("click", (e) => {
        e.preventDefault();
        let isValid = true;
        (0, jquery_1.default)(e.currentTarget)
            .next()
            .children()
            .each((index, element) => {
            if (!(element instanceof HTMLInputElement)) {
                return false;
            }
            if (element.value === "") {
                isValid = false;
                return false;
            }
        });
        if (isValid) {
            (0, jquery_1.default)(e.currentTarget).closest("form").trigger("submit");
        }
        else {
            alert("取得する期間を設定してください。");
        }
    });
    (0, jquery_1.default)(".js-datepicker-from")
        .datepicker()
        .on("change", (e) => {
        if (!(e.currentTarget instanceof HTMLInputElement)) {
            return false;
        }
        (0, jquery_1.default)(e.currentTarget)
            .parent()
            .find(".js-datepicker-to")
            .datepicker("option", "minDate", getDate(e.currentTarget));
    });
    (0, jquery_1.default)(".js-datepicker-to")
        .datepicker()
        .on("change", (e) => {
        if (!(e.currentTarget instanceof HTMLInputElement)) {
            return false;
        }
        (0, jquery_1.default)(e.currentTarget)
            .parent()
            .find(".js-datepicker-from")
            .datepicker("option", "maxDate", getDate(e.currentTarget));
    });
};
exports.batchDownloadDatepicker = batchDownloadDatepicker;
/**
 * 指定された形式で文字列値から日付を抽出する
 *
 * @param {HTMLInputElement} element
 * @returns {Date|null}
 */
const getDate = (element) => {
    let date;
    try {
        date = jquery_1.default.datepicker.parseDate(dateFormat, element.value);
    }
    catch (error) {
        date = null;
    }
    return date;
};
